import { IconFn, IconSvg } from "../createIcon";

export const SunIcon: IconFn = ({ color = "#050203", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 20, height: 20 }} {...props}>
    <path
      d="M10 4a1 1 0 0 0 1-1V1a1 1 0 0 0-2 0v2a1 1 0 0 0 1 1Zm9 5h-2a1 1 0 1 0 0 2h2a1 1 0 0 0 0-2ZM4 10a1 1 0 0 0-1-1H1a1 1 0 0 0 0 2h2a1 1 0 0 0 1-1Zm.22-7a1.012 1.012 0 1 0-1.39 1.47l1.44 1.39a1 1 0 0 0 .73.28 1 1 0 0 0 .72-.31 1 1 0 0 0 0-1.41L4.22 3ZM15 6.14a1 1 0 0 0 .69-.28l1.44-1.39A1 1 0 0 0 15.78 3l-1.44 1.42a1 1 0 0 0 0 1.41 1 1 0 0 0 .66.31ZM10 16a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1Zm5.73-1.86a1.001 1.001 0 0 0-1.39 1.44L15.78 17a1 1 0 0 0 1.41-.02 1.002 1.002 0 0 0 0-1.42l-1.46-1.42Zm-11.46 0-1.44 1.39a1 1 0 0 0 0 1.42 1 1 0 0 0 .72.3 1 1 0 0 0 .67-.25l1.44-1.39a1 1 0 1 0-1.39-1.44v-.03ZM10 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"
      fill={color}
    />
  </IconSvg>
);
